// extracted by mini-css-extract-plugin
export default {"review":"ReviewItem_review__++Qbk","profilePic":"ReviewItem_profilePic__lBULp","link":"ReviewItem_link__fXQ9s"};